<template>
<v-row>
      <v-col cols="12">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateStart"
                label="Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="clickClear"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateStart"
              @input="menu1 = false"
              :picker-date.sync="dateStart"
              :allowed-dates="allowedDateStart"
              @click:date="click"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-spacer></v-spacer>
  </v-row>
</template>

<script>
export default {
    props: {
      start: {
        type: String
      },
      end: {
        type: String
      }     
    },
    data() {
    return {
      menu1: false,
      menu2: false,
      dateStart: this.start,
      dateEnd: this.end,
    }
  },
  methods: {
      clickClear() {
        this.dateStart = null
        this.$emit('getDates', { dateStart: this.dateStart});
      },
      click() {
        this.$emit('getDates', { dateStart: this.dateStart});
      },
      allowedDateStart(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      }
  },
  watch: {
    start: function () {
      this.dateStart = this.start
      this.dateEnd = this.end
      this.click();
    },
  }
};
</script>

<style>
</style>